export default "__VITE_ASSET__CNl_birj__"